module.exports = __webpack_public_path__ + "img/album17_13.f68239e4.jpg";